<template>
  <v-container>

    <v-flex @click="gotoLanding" style="cursor:pointer">
      <!-- img src="../../static/images/smartkidsmarket-logo.svg" style="height:100px"/ -->
      <h2>NaloxoFind Contributor Login</h2>
      <h2>{{loginState}}</h2>
    </v-flex>

    <v-layout align-center align-content-center column>
        <v-flex v-if="errorText" class="subheading error--text">
          {{errorText}}
        </v-flex>

        <v-flex v-if="statusMessage" class="font-weight-bold subheading success--text">
          {{statusMessage}}
        </v-flex>
    </v-layout>


    <div v-if="needEmail">
      Please confirm your email address:
      <v-text-field
        id="email"
        v-model="email"
        :rules="[rules.required, rules.email]"
        name="email"
        label="Email"
        color="red"/>

      <v-btn
          :disabled="!valid"
          color="success"
          @click="finishLogin">Complete Login</v-btn>

    </div>

    <v-form
      v-show="showForm"
      ref="form"
      v-model="valid"
      v-on:submit.prevent="sendLoginLink"
      >
      <v-flex xs12>
        <v-text-field
          id="email"
          v-model="email"
          :rules="[rules.required, rules.email]"
          name="email"
          label="Email"
          color="red"/>
      </v-flex>

      <v-flex>
        <v-btn
          :disabled="!valid"
          color="success"
          :loading="inprogress"
          @click="sendLoginLink">Send login link</v-btn>

        <p class="title">You don't have an account?
          <router-link to="/signup">Sign up!</router-link>
        </p>

      </v-flex>
    </v-form>
  </v-container>

</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

import config from '../config.js'
// import store from '../store.js'

// Posible states here:
//    Not logged in and hit the URL --> Show form to send email link
//    Logged in and hit the URL --> Go to next page
//    Not logged in and hit the URL from loginLink --> Confirm email and go to next page
//    Logged in and hit the URL from loginLink --> Go to next page

export default {
  data () {
    return {
      inprogress: false,
      needEmail: false,
      errorText: null,
      loginState: "Processing",
      statusMessage: null,
      showForm: false,
      valid: false,
      fromLoginLink: false,
      email: null,
      unsub: null,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 6 || 'Min 6 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  mounted:  function () {

    this.finishLogin()
    //     this.unsub = firebase.auth().onAuthStateChanged((user) => {
    //       // console.log("AUTH CHANGE IN LINK LOGIN")
    //       // if (this.unsub) {
    //       //   this.unsub()
    //       //   this.unsub = null
    //       // }
    //       //
    //       // if (user) {
    //       //   console.log("User already logged in")
    //       //   // User is already signed in.
    //       //   this.showForm = false
    //       //   this.loginState = "Moving on..."
    //       //   this.nextPage(user.uid) // Go to the next page (whatever that should be)
    //       // }
    //     });    
  },
  methods: {

    gotoLanding: function () {
      this.$router.push('/')
    },

    doSignInWithEmail: function (email) {

      if (email == null) {
        this.loginState = "Error: Login again"
        console.error("Error, missing email in doSignInWithEmail")
        this.errorText = "Missing email, login again"
        this.showForm = true
        return
      }
      console.log("Using email for login: "+email)

      // The client SDK will parse the code from the link for you.
      firebase.auth().signInWithEmailLink(email, window.location.href)
        .then((userCred) => {
          console.log("email link signin complete?")

          // Clear email from storage.
          window.localStorage.removeItem('emailForSignIn');
          // You can access the new user via result.user
          // Additional user info profile not available via:
          // result.additionalUserInfo.profile == null
          // You can check if the user is new or existing:
          // result.additionalUserInfo.isNewUser

          // Send them to the next page
          if (userCred.user !== null) {
              console.log("Send to next page")

              this.nextPage(userCred.user.uid)
          } else {
              console.log("Error login again")
              this.loginState = "Error: Login again"
              this.showForm = true
          }
        })
        .catch((error) => {
          // Some error occurred, you can inspect the code: error.code
          // Common errors could be invalid email and invalid or expired OTPs.
          this.loginState = "Error: Login again"
          console.error("Error signing in with email link: "+error)
          this.errorText = error.message
          this.showForm = true
        });
    },

    finishSignInEmailLink: function () {
      this.needEmail = false

      this.loginState = "Finishing"
      this.fromLoginLink = true

      // Get the email if available from the window.
      var email = window.localStorage.getItem('emailForSignIn');
      if (email) {
        console.log("Got email from window...")
        this.doSignInWithEmail(email)
      } else if (this.email !== null) {
        console.log("Got email from form...")
        // We have it from the form!
        this.doSignInWithEmail(this.email)
      } else {
        console.log("Need to get email...")
        // We don't have it, we need to ask for it.
        this.needEmail = true
      }
    },

    finishLogin: function () {

      // Confirm the link is a sign-in with email link.
      if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
        console.log("We're here from sign in link")
        this.finishSignInEmailLink()
      } else if (firebase.auth().currentUser !== null) {
          // We're already logged in!
          this.$router.push({"name":"LocManager"})
      } else {
        console.log("We're NOT here from sign in link")
        this.showForm = true
        this.loginState = ""
      }

    },

    nextPage: async function () {
      // Send them to the next page

      this.$router.push({name: 'LocManager'})
      // // Are they a contributor?
      // const parent = await this.isParent(uid)
      // console.log('isParent in LinkLogin: '+parent)
      //
      // if (parent) {
      //     this.$router.push({name: 'ParentPortal'})
      // } else {
      //     this.$router.push({name: 'Dashboard'})
      // }
    },

    isExistingUser: async function () {
      try {
        // Now link them and charge the account
        var isUserContributor = config.getFunctions().httpsCallable('isUserContributor')
        const rc = await isUserContributor(
          {
            email: this.email
          }
        )
        console.log("isUserContributor return: "+JSON.stringify(rc.data))
        return rc.data
      } catch (err) {
        console.error('ERROR checking user: ' + JSON.stringify(err))
        this.errorText = err.message
        this.inprogress = false
      }
    },

    sendLoginLink: async function () {
      console.log("SEND LOGIN LINK")
      this.errorText= null
      this.statusMessage= null

      this.inprogress = true
      // Send a notification to the new parent
      // Admin SDK API to generate the sign in with email link.
      const actionCodeSettings = {
        // URL you want to redirect back to. The domain (www.example.com) for
        // this URL must be whitelisted in the Firebase Console.
        url: config.serverLoc+'login',
        // This must be true for email link sign-in.
        handleCodeInApp: true,
        // FDL custom domain.
        // dynamicLinkDomain: config.webDomain
      };

      const isUser = await this.isExistingUser(this.email)

      if (this.errorText != null) {
        this.inprogress = false
        return
      } else if (!isUser) {
        this.errorText = "That email isn't a valid contributing user yet. Sign up first!"
        this.inprogress = false
        return
      }

      // Okay, now we can login
      firebase.auth().sendSignInLinkToEmail(this.email, actionCodeSettings).then(
        () => {
          // Save the email locally so you don't need to ask the user for it again
          // if they open the link on the same device.
          window.localStorage.setItem('emailForSignIn', this.email);

          this.statusMessage = "A login email was sent. Click on the link in that email."
          this.showForm = false
          this.inprogress = false
        }).catch((err) => {
          alert('Oops. ' + err.message)
        })
    },

  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

.login {
  margin-top: 40px;
}

input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}

h2 {
  text-align: center;
}

button {
  margin-top: 20px;
  cursor: pointer;
}

p {
  margin-top: 40px;
  font-size: 13px;
}

p a {
  text-decoration: underline;
  cursor: pointer;
}
</style>
